export const WIDGET_POST_DETAILS_TYPE = 'post-details';
